import component from './evaluation.component'
import './evaluation.scss'

let module = angular.module('evaluation', [])
	.component('evaluation', component)
	.name;

export default module;


// WEBPACK FOOTER //
// ./app/components/evaluation/evaluation.js